import React from 'react';
import useModalVisibility from 'components/common/hooks/useModalVisibility';
import { Modal } from 'components/common/Modal';
import './BriefList.scss';
function BriefList({ data, count, keyFn, itemRenderer, header, placeholder, }) {
    var _a;
    const [isModalVisible, showModal, hideModal] = useModalVisibility(false);
    if (data.length === 0)
        return React.createElement("span", null, placeholder);
    return (React.createElement(React.Fragment, null, (_a = data === null || data === void 0 ? void 0 : data.slice(0, count)) === null || _a === void 0 ? void 0 :
        _a.map((item, i) => (React.createElement("span", { key: keyFn(item) },
            i === 0 ? '' : ', ',
            itemRenderer(item)))),
        data.length > count && (React.createElement(React.Fragment, null,
            ' ',
            React.createElement("span", { "aria-hidden": true, className: "brief-item", onClick: showModal },
                "+\u00A0",
                data.length - count),
            React.createElement(Modal, { title: header, open: isModalVisible, close: hideModal },
                React.createElement("div", { className: "modal__wrapper" },
                    React.createElement("ul", null, data.map((item) => (React.createElement("li", { key: keyFn(item) }, itemRenderer(item)))))))))));
}
export default BriefList;
